import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Search from "../Search";

type Props = {
  handleSearch: (val: string) => void;
  searchQuery: string;
};

const TransactionHeader = ({ handleSearch, searchQuery }: Props) => {
  return (
    <StyledTransactionHeader>
      <StyledPageHeader>Top Up Transactions</StyledPageHeader>
      <TransactionHeaderActions>
        <Search
          placeholder="Search"
          onChange={handleSearch}
          value={searchQuery}
        />
      </TransactionHeaderActions>
    </StyledTransactionHeader>
  );
};

const StyledTransactionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.25rem;
`;

const StyledPageHeader = styled.div`
  color: ${Colors.black};
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const TransactionHeaderActions = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export default TransactionHeader;
